export var defaultItemTypes = {
    task: { color: '#E3B23C', backgroundColor: 'white' },
    bug: { color: '#b80016', backgroundColor: '#faedef' },
    story: { color: '#0094ff', backgroundColor: 'white' },
    feature: { color: '#7564b6', backgroundColor: 'white' },
    epic: { color: '#ff6a00', backgroundColor: 'white' },
};
export var defaultStates = [
    { name: 'To do', status: 0 },
    { name: 'In progress', status: 1 },
    { name: 'Done', status: 2 },
];
export var defaultItemType = defaultItemTypes.task;
export var defaultGroupType = defaultItemTypes.story;
export var collapsedGroupHeight = 36;
export var groupHeight = 130;
export var getStateWidth = function (hideGroups, statesLength) {
    return "".concat((!hideGroups ? 85 : 100) / statesLength, "%");
};
export var groupWidth = '15%';
var state0 = {
    status: 0,
    name: 'To do',
    isCollapsedByDefaultForGroups: true,
};
var state1 = {
    status: 1,
    name: 'In progress',
    areNewItemButtonsHidden: true,
};
var state2 = {
    status: 2,
    name: 'Done',
    isCollapsedByDefaultForGroups: true,
    areNewItemButtonsHidden: true,
};
export var states = [state0, state1, state2];
export var taskColors = {
    blue: {
        color: '#f2f2f2',
        backgroundColor: '#f2f2f2',
    },
    red: {
        color: '#b80016',
        backgroundColor: '#faedef',
    },
    yellowOchre: {
        color: '#E3B23C',
        backgroundColor: '#f2f2f2',
    },
    green: {
        color: '#197d65',
        backgroundColor: '#f2f2f2',
    },
    purple: {
        color: '#7564b6',
        backgroundColor: '#e0dbfd',
    },
    dragging: {
        color: undefined,
        backgroundColor: '#f2f2f2',
    },
};
export var getTaskColor = function (task) {
    switch (typeof task === 'number' ? task : task.taskColor) {
        case 0:
            return taskColors.green;
        case 1:
            return taskColors.blue;
        case 2:
            return taskColors.yellowOchre;
        case 3:
            return taskColors.red;
        case 4:
            return taskColors.purple;
        default:
            return defaultItemType;
    }
};
export var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["Todo"] = 0] = "Todo";
    TaskStatus[TaskStatus["InProgress"] = 1] = "InProgress";
    TaskStatus[TaskStatus["Done"] = 2] = "Done";
})(TaskStatus || (TaskStatus = {}));
export var Method;
(function (Method) {
    Method[Method["ClickToOpenRegForm"] = 0] = "ClickToOpenRegForm";
    Method[Method["OpenFormOnDone"] = 1] = "OpenFormOnDone";
    Method[Method["AutomaticRegistration"] = 2] = "AutomaticRegistration";
})(Method || (Method = {}));
export var TaskType;
(function (TaskType) {
    TaskType[TaskType["ActualTask"] = 0] = "ActualTask";
    TaskType[TaskType["DefaultTime"] = 1] = "DefaultTime";
    TaskType[TaskType["Condition"] = 2] = "Condition";
    TaskType[TaskType["Mail"] = 3] = "Mail";
    TaskType[TaskType["AutomaticMail"] = 4] = "AutomaticMail";
})(TaskType || (TaskType = {}));
